import { DatePipe } from "@angular/common";
import {
  ChangeDetectorRef,
  DestroyRef,
  Directive,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  inject,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { ReplaySubject } from "rxjs";
import swal from "sweetalert2";
import { EmpleadoService } from "src/app/empleado/empleado.service";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { FiltrosIncidenciaEnum } from "src/app/shared/enum/filtro.incidencia.enum";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { Empleado } from "src/app/shared/model/empleado/empleado.model";
import { Etapa } from "src/app/shared/model/gestion-proyectos/etapa/etapa";
import { Proyecto } from "src/app/shared/model/gestion-proyectos/proyecto";
import { Incidencias } from "src/app/shared/model/incidencias/incidencia.model";
import { KanbanIncidencia } from "src/app/shared/model/incidencias/kanbanincidencia.model";
import { Proyectos } from "src/app/shared/model/incidencias/proyectos.model";
import { TiposFiltrosIncidencia } from "src/app/shared/model/incidencias/tiposFiltrosIncidencia.model";
import { ComunicacionService } from "src/app/shared/services/comunicacion.service";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { colorDePrioridad, equipoConPuesto } from "../etapa-incidencia.util";
import { IncidenciasService } from "../incidencias.service";

/** Formato con el que viaja al backend el rango de fechas del filtro. */
const FORMATO_FECHA = "dd/MM/yyyy";

/** Ícono de cada columna del tablero. */
export interface IconosColumnas {
  abierto: string;
  observaciones: string;
  proceso: string;
  resuelto: string;
  revision: string;
  vobo: string;
  cancelado: string;
}

/**
 * Tablero kanban de incidencias por proyecto y etapa, común a QA y a desarrollo: carga de proyectos y
 * etapas (recordadas en localStorage), consulta de las siete columnas por estatus, paginación por columna,
 * popover de filtros y arrastre horizontal del tablero. Cada pantalla conserva su plantilla y define los
 * íconos de sus columnas, sus claves de localStorage, el puesto y el campo del usuario que filtra, y lo que
 * hace distinto al abrir o limpiar filtros.
 */
@Directive()
export abstract class ListaIncidenciasBase implements OnInit {
  protected readonly router = inject(Router);
  protected readonly proyectoService = inject(ProyectosService);
  protected readonly incidenciasService = inject(IncidenciasService);
  protected readonly comunicacion = inject(ComunicacionService);
  protected readonly datePipe = inject(DatePipe);
  protected readonly empleadoService = inject(EmpleadoService);
  protected readonly cdr = inject(ChangeDetectorRef);
  /** Una respuesta que llega con la vista ya destruida no se pinta: detectChanges() truena. */
  private destruido = false;
  /**
   * La primera consulta espera a saber el puesto del usuario: el desarrollador
   * y el tester sólo ven lo suyo. Antes, si los proyectos llegaban primero,
   * salía otra consulta sin ese filtro y ganaba la que respondiera al último.
   */
  private puestoResuelto = false;

  /** Ícono de cada columna del tablero. */
  protected abstract readonly iconosColumnas: IconosColumnas;
  /** Claves de localStorage con el proyecto y la etapa elegidos. */
  abstract IncSelProy: string;
  abstract IncSelEtapa: string;
  /** Puesto con el que se consultan los empleados del filtro. */
  protected abstract readonly puestoEmpleados: string;
  /** Campo del bean con el usuario que filtra la consulta. */
  protected abstract readonly campoUsuario: "id_usuario_qa" | "id_usuario_desarrollo";

  p: number[] = [];
  collection = { count: 60, data: [] };

  selectProyecto: number;
  selectEtapa: number;
  listaGlobal = new Array<KanbanIncidencia>();
  activaproyecto: boolean;
  inicio = 0;
  regPag = 3;
  config: any;
  configTwo: any;
  mostrarEtapa: boolean = false;

  abierto: boolean;
  public directionLinks = true;
  public autoHide = false;
  public responsive = true;
  public labels: any = {
    previousLabel: "<",
    nextLabel: ">",
    screenReaderPaginationLabel: "Pagination",
    screenReaderPageLabel: "page",
    screenReaderCurrentLabel: `You're on page`,
  };
  consultaObject = new ConsultaList<Incidencias>();
  public esDesarrolloDesarrollador = false;

  // filtros
  verFiltros = new FormControl();
  listatiposfiltros: TiposFiltrosIncidencia[];
  verFiltro: string;
  selectedValueFiltro: string;
  verestatus = new FormControl();
  listaEstatus: string[] = [
    "ABIERTO",
    "OBSERVACIONES",
    "PROCESO",
    "RESUELTO",
    "REVISION",
    "VOBO",
    "CANCELADO",
  ];
  estatus: boolean;
  nombre: boolean;
  fecha: boolean;
  numero: boolean;
  prioridad: boolean;
  emp: boolean;
  search: boolean;
  prioridades = new FormControl();
  listaprioridades: any;
  milistafiltro = [];
  nombre_incidencia: string;
  fec_ini: string;
  fec_fin: string;
  verPrioridad: string;
  selectedValuePrioridad: string;
  titulo: string = "";
  numeroInci: number;
  milistaestatus = [];
  activo: boolean;
  verfiltros: string;
  dejardeverfiltros: boolean;
  texto = "Filtros";
  estadoPositivo = true;
  idUsuario: number;
  listaFiltros: [];
  listaEmpleados: Empleado[] = [];

  // paginado de cada columna
  current = false;
  configAbierto: any;
  configObservacion: any;
  configProceso: any;
  configResuelto: any;
  configRevision: any;
  configVOBO: any;
  configCancelado: any;

  listaIncAbierto: any[] = [];
  totalAbierto: number;
  listaIncObservacion: any[] = [];
  totalObservacion: number;
  listaIncProceso: any[] = [];
  totalProceso: number;
  listaIncResuelto: any[] = [];
  totalResuelto: number;
  listaIncRevision: any[] = [];
  totalRevision: number;
  listaIncVOBO: any[] = [];
  totalVOBO: number;
  listaIncCancelado: any[] = [];
  totalCancelado: number;
  proy: any;
  requestFilter = new ConsultaList<Proyecto>();

  // filtro por tipo
  listaTipo: any;
  tipo: boolean;
  tipos = new FormControl();
  milistafiltrotipo = [];

  minDate: Date = new Date();
  maxDate: Date = new Date();
  loading = false;
  readonly pageSizeOptions = [3, 5, 10];
  @ViewChild("boardScroller") boardScroller?: ElementRef<HTMLDivElement>;
  @ViewChild("filtersButton", { read: ElementRef }) filtersButton?: ElementRef<HTMLElement>;
  @ViewChild("filtersPopover") filtersPopover?: ElementRef<HTMLDivElement>;
  isDraggingBoard = false;
  private dragStartX = 0;
  private dragStartScrollLeft = 0;
  filtersPopupOpen = false;

  listaproyectos: Array<Proyectos>;
  listaetapas: Array<Etapa>;

  formProyecto = new FormControl();
  formEtapa = new FormControl();
  public filterProyecto: ReplaySubject<Proyectos[]> = new ReplaySubject<
    Proyectos[]
  >(1);
  public filterEtapa: ReplaySubject<Etapa[]> = new ReplaySubject<Etapa[]>(1);

  constructor() {
    inject(DestroyRef).onDestroy(() => {
      this.destruido = true;
    });
  }

  /** Asigna el usuario que filtra según el puesto del empleado en sesión. */
  protected abstract asignaUsuarioPorPuesto(emp: Empleado): void;

  /** Al abrir el popover: cada pantalla prepara sus catálogos de filtros. */
  abstract prepararFiltrosDisponibles(): void;

  /** Limpia los filtros tras elegir cuáles se usan (capturafiltro). */
  abstract limpiaFiltros(): void;

  /** Botón Limpiar del popover de filtros. */
  abstract limpiaFiltrosPopup(): void;

  /** Aviso cuando hay fecha final sin fecha inicial. */
  protected abstract avisaFechaInicial(): void;

  ngOnInit() {
    this.instanciasPaginados();
    const iconos = this.iconosColumnas;
    this.listaGlobal.push(
      new KanbanIncidencia(Constantes.ABIERTO, new Array<Incidencias>(), iconos.abierto, Constantes.ABIERTOCOLOR),
      new KanbanIncidencia(Constantes.OBSERVACIONES, new Array<Incidencias>(), iconos.observaciones, Constantes.OBSERVACIONESCOLOR),
      new KanbanIncidencia(Constantes.PROCESO, new Array<Incidencias>(), iconos.proceso, Constantes.PROCESOCOLOR),
      new KanbanIncidencia(Constantes.RESUELTO, new Array<Incidencias>(), iconos.resuelto, Constantes.RESUELTOCOLOR),
      new KanbanIncidencia(Constantes.REVISION, new Array<Incidencias>(), iconos.revision, Constantes.REVISIONCOLOR),
      new KanbanIncidencia(Constantes.VOBO, new Array<Incidencias>(), iconos.vobo, Constantes.VOBOCOLOR),
      new KanbanIncidencia(Constantes.CANCELADO, new Array<Incidencias>(), iconos.cancelado, Constantes.CANCELADOCOLOR)
    );
    this.consultaproyectos();
    this.consultaAreaPuestoEmpleado();

    this.formProyecto.valueChanges.subscribe(() => {
      this.filtraProyectos();
    });
    this.formEtapa.valueChanges.subscribe(() => {
      this.filtraEtapa();
    });
  }

  filtraProyectos() {
    if (!this.listaproyectos) {
      return;
    }

    let search = this.formProyecto.value;
    if (!search) {
      this.filterProyecto.next(this.listaproyectos.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterProyecto.next(
      this.listaproyectos.filter((proyecto) =>
        proyecto.nombre.toLowerCase().includes(search)
      )
    );
  }

  filtraEtapa() {
    if (!this.listaetapas) {
      return;
    }

    let search = this.formEtapa.value;
    if (!search) {
      this.filterEtapa.next(this.listaetapas.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterEtapa.next(
      this.listaetapas.filter((etapa) =>
        etapa.nombre.toLowerCase().includes(search)
      )
    );
  }

  /**
   * Verifica qué tipo de usuario es (líder, tester o desarrollador) antes de la
   * primera consulta. Si no se puede saber, se consulta sin filtro de usuario.
   */
  consultaAreaPuestoEmpleado() {
    this.empleadoService.consultaAreaPuestoEmpleado().subscribe({
      next: (emp) => {
        if (emp?.puesto) {
          this.asignaUsuarioPorPuesto(emp);
        }
        this.puestoResuelto = true;
        this.consultaincidencias();
      },
      error: () => {
        this.puestoResuelto = true;
        this.consultaincidencias();
      },
    });
  }

  consultaproyectos() {
    this.requestFilter.param6 = 6;
    this.requestFilter.regXPagina = Constantes.MIL;

    this.proyectoService
      .consultaProyectoMongo(this.requestFilter)
      .subscribe((response: any) => {
        if (!response?.content?.length) {
          swal
            .fire({
              title: " ¡No tiene proyectos asociados! ",
              text: " Verifique estar asignado a un proyecto ",
              timer: 6000,
              icon: "info",
              customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-danger",
              },
              showConfirmButton: false,
            })
            .then(() => {});
          this.listaproyectos = [];
        } else {
          this.listaproyectos = response.content;
          this.refreshPantalla();
          this.filterProyecto.next(this.listaproyectos.slice());
        }
        this.repinta();
      });
  }

  /** Captura el proyecto elegido. */
  capturarProyecto(id) {
    this.selectProyecto = id;
    this.mostrarEtapa = true;
    localStorage.setItem(this.IncSelProy, JSON.stringify(id));
    localStorage.removeItem(this.IncSelEtapa);
    // Antes de las etapas: al elegir la etapa, el filtro de empleados sale de este proyecto.
    this.proy = this.listaproyectos.find(
      (select) => select.id === id
    );
    this.consultaetapas(id);
  }

  refreshPantalla() {
    if (!this.listaproyectos?.length) {
      return;
    }

    const item = localStorage.getItem(this.IncSelProy);
    const proyectoGuardado = item ? JSON.parse(item) : null;
    const proyectoValido = this.listaproyectos.find(
      (select) => select.id === proyectoGuardado
    );
    const proyectoInicial = proyectoValido ?? this.listaproyectos[0];

    if (!proyectoInicial) {
      return;
    }

    this.selectProyecto = proyectoInicial.id;
    this.mostrarEtapa = true;
    this.proy = proyectoInicial;
    localStorage.setItem(this.IncSelProy, JSON.stringify(proyectoInicial.id));
    this.consultaetapas(proyectoInicial.id);
  }

  /** Consulta las etapas del proyecto y elige la guardada o la primera. */
  consultaetapas(id: number) {
    const proyectoEncontrado = this.listaproyectos.find(
      (proyecto) => proyecto.id === id
    );
    if (proyectoEncontrado) {
      this.listaetapas = proyectoEncontrado.etapas || [];
      this.filterEtapa.next(this.listaetapas.slice());

      const item = localStorage.getItem(this.IncSelEtapa);
      const etapaGuardada = item ? JSON.parse(item) : null;
      const etapaValida = this.listaetapas.find(
        (etapa) => etapa.id === etapaGuardada
      );
      const etapaInicial = etapaValida ?? this.listaetapas[0];

      if (etapaInicial) {
        this.selectEtapa = etapaInicial.id as any;
        this.activaproyecto = true;
        this.capturaretapa(etapaInicial.id);
      } else {
        this.selectEtapa = Number.NaN;
        this.activaproyecto = false;
      }
    } else {
      console.log("No se encontró ningún proyecto con el ID especificado.");
    }
  }

  /** Captura la etapa elegida. */
  capturaretapa(etapas: number | string) {
    localStorage.setItem(this.IncSelEtapa, JSON.stringify(etapas));
    this.selectEtapa = etapas as any;
    this.alCambiarEtapa();
    this.consultaincidencias();
    this.activaproyecto = true;
  }

  /** Desarrollo recarga aquí los catálogos de filtros; QA los carga al abrir el popover. */
  protected alCambiarEtapa(): void {
    // Sin acción por omisión.
  }

  /** Consulta las siete columnas desde la primera página. */
  consultaincidencias() {
    if (!this.puestoResuelto) {
      // consultaAreaPuestoEmpleado() la vuelve a pedir en cuanto sepa el puesto.
      return;
    }

    if (!this.selectProyecto || !this.selectEtapa) {
      this.loading = false;
      return;
    }

    this.loading = true;
    this.repinta();
    this.consultaObject.bean = new Incidencias();
    this.consultaObject.bean.id_proyecto = this.selectProyecto; // filtro idProyecto
    this.consultaObject.bean.id_etapa = this.selectEtapa; // filtro idEtapa
    this.consultaObject.regInicial = this.inicio; // tamaño inicial para rowStart en DaoImpl
    this.consultaObject.regXPagina = this.regPag; // tamaño que se manda para extraer un rowEnd en DaoImpl
    this.consultaObject.bean.estatus = null;
    this.consultaObject.bean.titulo = this.titulo; // filtro nombre incidencia
    this.consultaObject.bean.numeroInci = this.numeroInci; // filtro numeroInc
    this.consultaObject.bean.milistaprioridad = this.milistafiltro;
    this.consultaObject.bean.milistatipo = this.milistafiltrotipo;
    this.consultaObject.bean.milistaestatus = this.milistaestatus;
    this.consultaObject.bean[this.campoUsuario] = this.idUsuario;
    this.consultaObject.bean.esDesarrolloDesarrollador =
      this.esDesarrolloDesarrollador;
    this.asignaRangoFechas(this.consultaObject.bean);

    this.pideIncidencias(this.consultaObject, (res) => {
      this.reiniciaPaginado();
      this.valores(res);
      this.abierto = true;
    });
  }

  valores(res: ConsultaList<Incidencias>) {
    if (res.bean2.incDTO.listaIncAbierto !== null) {
      this.listaIncAbierto = res.bean2.incDTO.listaIncAbierto;
      this.configAbierto.totalItems = res.bean2.incDTO.totalItemsAbierto;
      this.listaIncAbierto.forEach((ab) => {
        ab.descincidencia =
          ab.descincidencia === null ? "Sin Descripcion" : ab.descincidencia;
        ab.colorEstatus = Constantes.ABIERTOCOLOR;
        this.validaIncidenciaPrioridad(ab);
      });
    } else if (!this.current) {
      this.listaIncAbierto = [];
      this.configAbierto.totalItems = res.bean2.incDTO.totalItemsAbierto;
    }

    if (res.bean2.incDTO.listaIncObservacion !== null) {
      this.listaIncObservacion = res.bean2.incDTO.listaIncObservacion;
      this.configObservacion.totalItems =
        res.bean2.incDTO.totalItemsObservacion;
      this.listaIncObservacion.forEach((ab) => {
        ab.descincidencia =
          ab.descincidencia === null ? "Sin Descripcion" : ab.descincidencia;
        ab.colorEstatus = Constantes.OBSERVACIONESCOLOR;
        this.validaIncidenciaPrioridad(ab);
      });
    } else if (!this.current) {
      this.listaIncObservacion = [];
      this.configObservacion.totalItems =
        res.bean2.incDTO.totalItemsObservacion;
    }

    if (res.bean2.incDTO.listaIncProceso !== null) {
      this.listaIncProceso = res.bean2.incDTO.listaIncProceso;
      this.configProceso.totalItems = res.bean2.incDTO.totalItemsProceso;
      this.listaIncProceso.forEach((ab) => {
        ab.descincidencia =
          ab.descincidencia === null ? "Sin Descripcion" : ab.descincidencia;
        ab.colorEstatus = Constantes.PROCESOCOLOR;
        this.validaIncidenciaPrioridad(ab);
      });
    } else if (!this.current) {
      this.listaIncProceso = [];
      this.configProceso.totalItems = res.bean2.incDTO.totalItemsProceso;
    }

    if (res.bean2.incDTO.listaIncResuelto !== null) {
      this.listaIncResuelto = res.bean2.incDTO.listaIncResuelto;
      this.configResuelto.totalItems = res.bean2.incDTO.totalItemsResuelto;
      this.listaIncResuelto.forEach((ab) => {
        ab.descincidencia =
          ab.descincidencia === null ? "Sin Descripcion" : ab.descincidencia;
        ab.colorEstatus = Constantes.RESUELTOCOLOR;
        this.validaIncidenciaPrioridad(ab);
      });
    } else if (!this.current) {
      this.listaIncResuelto = [];
      this.configResuelto.totalItems = res.bean2.incDTO.totalItemsResuelto;
    }

    if (res.bean2.incDTO.listaIncRevision !== null) {
      this.listaIncRevision = res.bean2.incDTO.listaIncRevision;
      this.configRevision.totalItems = res.bean2.incDTO.totalItemsRevision;
      this.listaIncRevision.forEach((ab) => {
        ab.descincidencia =
          ab.descincidencia === null ? "Sin Descripcion" : ab.descincidencia;
        ab.colorEstatus = Constantes.REVISIONCOLOR;
        this.validaIncidenciaPrioridad(ab);
      });
    } else if (!this.current) {
      this.listaIncRevision = [];
      this.configRevision.totalItems = res.bean2.incDTO.totalItemsRevision;
    }

    if (res.bean2.incDTO.listaIncVOBO !== null) {
      this.listaIncVOBO = res.bean2.incDTO.listaIncVOBO;
      this.configVOBO.totalItems = res.bean2.incDTO.totalItemsVOBO;
      this.listaIncVOBO.forEach((ab) => {
        ab.descincidencia =
          ab.descincidencia === null ? "Sin Descripcion" : ab.descincidencia;
        ab.colorEstatus = Constantes.VOBOCOLOR;
        this.validaIncidenciaPrioridad(ab);
      });
    } else if (!this.current) {
      this.listaIncVOBO = [];
      this.configVOBO.totalItems = res.bean2.incDTO.totalItemsVOBO;
    }

    if (res.bean2.incDTO.listaIncCancelado !== null) {
      this.listaIncCancelado = res.bean2.incDTO.listaIncCancelado;
      this.configCancelado.totalItems = res.bean2.incDTO.totalItemsCancelado;
      this.listaIncCancelado.forEach((ab) => {
        ab.descincidencia =
          ab.descincidencia === null ? "Sin Descripcion" : ab.descincidencia;
        ab.colorEstatus = Constantes.CANCELADOCOLOR;
        this.validaIncidenciaPrioridad(ab);
      });
    } else if (!this.current) {
      this.listaIncCancelado = [];
      this.configCancelado.totalItems = res.bean2.incDTO.totalItemsCancelado;
    }
  }

  validaIncidenciaPrioridad(inc: Incidencias) {
    inc.color = colorDePrioridad(inc.prioridad) ?? inc.color;
  }

  instanciasPaginados() {
    this.configAbierto = {
      id: "eAbierto",
      currentPage: 1,
      itemsPerPage: this.regPag,
      totalItems: 0,
    };
    this.configObservacion = {
      id: "eObservacion",
      currentPage: 1,
      itemsPerPage: this.regPag,
      totalItems: 0,
    };
    this.configProceso = {
      id: "eProceso",
      currentPage: 1,
      itemsPerPage: this.regPag,
      totalItems: 0,
    };
    this.configResuelto = {
      id: "eResuelto",
      currentPage: 1,
      itemsPerPage: this.regPag,
      totalItems: 0,
    };
    this.configRevision = {
      id: "eRevision",
      currentPage: 1,
      itemsPerPage: this.regPag,
      totalItems: 0,
    };
    this.configVOBO = {
      id: "eVOBO",
      currentPage: 1,
      itemsPerPage: this.regPag,
      totalItems: 0,
    };
    this.configCancelado = {
      id: "eCancelado",
      currentPage: 1,
      itemsPerPage: this.regPag,
      totalItems: 0,
    };
  }

  getTotalPages(config: { totalItems?: number; itemsPerPage?: number }): number {
    const totalItems = Number(config?.totalItems ?? 0);
    const itemsPerPage = Number(config?.itemsPerPage ?? 0);

    return totalItems > 0 && itemsPerPage > 0
      ? Math.ceil(totalItems / itemsPerPage)
      : 0;
  }

  pageChanged(event, valor) {
    this.loading = true;
    this.repinta();
    this.consultaObject.bean.id_proyecto = this.selectProyecto;
    this.consultaObject.bean.id_etapa = this.selectEtapa;
    this.consultaObject.regInicial =
      this.inicio + event * this.regPag - this.regPag;
    this.consultaObject.regXPagina = this.regPag;
    this.current = true;
    this.validaCurrentPage(event, valor);
  }

  validaCurrentPage(event, valor) {
    this.consultaObject.bean.milistaestatus = [];

    switch (valor) {
      case Constantes.ABIERTO: {
        this.configAbierto.currentPage = event;
        break;
      }
      case Constantes.OBSERVACIONES: {
        this.configObservacion.currentPage = event;
        break;
      }
      case Constantes.PROCESO: {
        this.configProceso.currentPage = event;
        break;
      }
      case Constantes.RESUELTO: {
        this.configResuelto.currentPage = event;
        break;
      }
      case Constantes.REVISION: {
        this.configRevision.currentPage = event;
        break;
      }
      case Constantes.VOBO: {
        this.configVOBO.currentPage = event;
        break;
      }
      case Constantes.CANCELADO: {
        this.configCancelado.currentPage = event;
        break;
      }
    }
    if (this.emp === false) {
      this.idUsuario = null;
    }

    this.consultaObject.bean.estatus = valor;
    this.consultaObject.bean.esDesarrolloDesarrollador =
      this.esDesarrolloDesarrollador;
    this.consultaIncidenciasPageChanged(this.consultaObject);
  }

  consultaIncidenciasPageChanged(consultaObject) {
    this.consultaObject.regXPagina = this.regPag;
    this.pideIncidencias(consultaObject, (res) => {
      this.valores(res);
    });
  }

  reiniciaPaginado() {
    this.configAbierto.currentPage = 1;
    this.configObservacion.currentPage = 1;
    this.configProceso.currentPage = 1;
    this.configResuelto.currentPage = 1;
    this.configRevision.currentPage = 1;
    this.configVOBO.currentPage = 1;
    this.configCancelado.currentPage = 1;
  }

  /* ---------- Filtros ---------- */
  activafiltros(event?: MouseEvent) {
    event?.stopPropagation();

    if (this.filtersPopupOpen) {
      this.cerrarFiltrosPopup();
      return;
    }

    this.prepararFiltrosDisponibles();
    this.filtersPopupOpen = true;
    this.cdr.detectChanges();
  }

  cerrarFiltrosPopup() {
    this.filtersPopupOpen = false;
    this.cdr.detectChanges();
  }

  @HostListener("document:click", ["$event"])
  handleDocumentClick(event: MouseEvent) {
    if (!this.filtersPopupOpen) {
      return;
    }

    const target = event.target as Node | null;
    const clickedInsidePopover = !!(
      target &&
      this.filtersPopover?.nativeElement?.contains(target)
    );
    const clickedButton = !!(
      target &&
      this.filtersButton?.nativeElement?.contains(target)
    );

    if (!clickedInsidePopover && !clickedButton) {
      this.cerrarFiltrosPopup();
    }
  }

  @HostListener("document:keydown.escape")
  handleEscapeKey() {
    if (this.filtersPopupOpen) {
      this.cerrarFiltrosPopup();
    }
  }

  getActiveFiltersCount(): number {
    let count = 0;

    if (this.prioridades.value?.length) {
      count++;
    }
    if (this.tipos.value?.length) {
      count++;
    }
    if (this.verestatus.value?.length) {
      count++;
    }
    if (this.titulo?.trim()) {
      count++;
    }
    if (this.numeroInci) {
      count++;
    }
    if (this.idUsuario) {
      count++;
    }
    if (this.fec_ini || this.fec_fin) {
      count++;
    }

    return count;
  }

  reiniciaBanderas() {
    this.estatus = false;
    this.nombre = false;
    this.fecha = false;
    this.numero = false;
    this.prioridad = false;
    this.emp = false;
    this.tipo = false;
  }

  capturafiltro(nombreFiltro) {
    this.reiniciaBanderas();

    this.listaFiltros = nombreFiltro;
    this.listaFiltros.forEach((ab) => {
      switch (ab) {
        case "ESTATUS":
          this.estatus = true;
          break;
        case "NOMBRE":
          this.nombre = true;
          break;
        case "RANGO_FECHA":
          this.fecha = true;
          break;
        case "NUMERO_INCIDENCIA":
          this.numero = true;
          break;
        case "PRIORIDAD":
          this.cargaPrioridades();
          this.prioridad = true;
          break;
        case "EMPLEADO_ASIGNADO":
          this.cargaEmpleados();
          this.emp = true;
          break;
        case "TIPO":
          this.cargaTipos();
          this.tipo = true;
          break;
      }
    });
    this.limpiaFiltros();
  }

  applyFiltersIncidencias() {
    this.consultaObject.bean = new Incidencias();
    this.consultaObject.bean.id_proyecto = this.selectProyecto;
    this.consultaObject.bean.id_etapa = this.selectEtapa;
    this.consultaObject.bean[this.campoUsuario] = this.idUsuario;
    this.consultaObject.bean.esDesarrolloDesarrollador =
      this.esDesarrolloDesarrollador;
    this.consultaObject.bean.estatus = null;
    this.consultaObject.bean.milistaprioridad =
      this.prioridades.value !== null ? this.prioridades.value : [];
    this.consultaObject.bean.titulo = this.titulo;
    this.consultaObject.bean.milistaestatus =
      this.verestatus.value !== null ? this.verestatus.value : [];
    this.consultaObject.bean.numeroInci = this.numeroInci;
    this.consultaObject.bean.milistatipo =
      this.tipos.value !== null ? this.tipos.value : [];
    this.asignaRangoFechas(this.consultaObject.bean);
    this.current = false;
    this.consultaIncidenciasConFiltro(this.consultaObject);
  }

  consultaIncidenciasConFiltro(consultaObject) {
    this.loading = true;
    this.repinta();
    this.consultaObject.regInicial = this.inicio;
    this.consultaObject.regXPagina = this.regPag;
    this.pideIncidencias(consultaObject, (res) => {
      this.reiniciaPaginado();
      this.valores(res);
    });
  }

  /* ---------- Tablero y paginación ---------- */
  startBoardDrag(event: MouseEvent): void {
    const element = this.boardScroller?.nativeElement;
    if (!element) {
      return;
    }

    this.isDraggingBoard = true;
    this.dragStartX = event.clientX;
    this.dragStartScrollLeft = element.scrollLeft;
  }

  moveBoardDrag(event: MouseEvent): void {
    const board = this.boardScroller?.nativeElement;
    if (!this.isDraggingBoard || !board) {
      return;
    }

    const deltaX = event.clientX - this.dragStartX;
    board.scrollLeft = this.dragStartScrollLeft - deltaX;
  }

  stopBoardDrag(): void {
    this.isDraggingBoard = false;
  }

  get boardTotalItems(): number {
    return this.getConfigs().reduce(
      (total, config) => total + Number(config?.totalItems ?? 0),
      0
    );
  }

  getConfigByStatus(status: string): any {
    switch (status) {
      case Constantes.ABIERTO:
        return this.configAbierto;
      case Constantes.OBSERVACIONES:
        return this.configObservacion;
      case Constantes.PROCESO:
        return this.configProceso;
      case Constantes.RESUELTO:
        return this.configResuelto;
      case Constantes.REVISION:
        return this.configRevision;
      case Constantes.VOBO:
        return this.configVOBO;
      case Constantes.CANCELADO:
        return this.configCancelado;
      default:
        return null;
    }
  }

  getIncidenciasByStatus(status: string): Incidencias[] {
    switch (status) {
      case Constantes.ABIERTO:
        return this.listaIncAbierto;
      case Constantes.OBSERVACIONES:
        return this.listaIncObservacion;
      case Constantes.PROCESO:
        return this.listaIncProceso;
      case Constantes.RESUELTO:
        return this.listaIncResuelto;
      case Constantes.REVISION:
        return this.listaIncRevision;
      case Constantes.VOBO:
        return this.listaIncVOBO;
      case Constantes.CANCELADO:
        return this.listaIncCancelado;
      default:
        return [];
    }
  }

  getPaginationItems(config: {
    currentPage?: number;
    totalItems?: number;
    itemsPerPage?: number;
  }): Array<number | string> {
    const totalPages = this.getTotalPages(config);
    if (totalPages <= 1) {
      return [1];
    }

    const currentPage = Number(config?.currentPage ?? 1);
    const pages = new Set<number>([
      1,
      totalPages,
      currentPage - 1,
      currentPage,
      currentPage + 1,
    ]);
    const sortedPages = Array.from(pages)
      .filter((page) => page >= 1 && page <= totalPages)
      .sort((a, b) => a - b);

    const items: Array<number | string> = [];
    for (let index = 0; index < sortedPages.length; index++) {
      const page = sortedPages[index];
      const previous = sortedPages[index - 1];
      if (previous && page - previous > 1) {
        items.push(`ellipsis-${previous}-${page}`);
      }
      items.push(page);
    }

    return items;
  }

  isPageNumber(item: number | string): item is number {
    return typeof item === "number";
  }

  firstPage(status: string): void {
    this.changeStatusPage(status, 1);
  }

  previousPage(status: string): void {
    const config = this.getConfigByStatus(status);
    this.changeStatusPage(status, Number(config?.currentPage ?? 1) - 1);
  }

  nextPage(status: string): void {
    const config = this.getConfigByStatus(status);
    this.changeStatusPage(status, Number(config?.currentPage ?? 1) + 1);
  }

  lastPage(status: string): void {
    this.changeStatusPage(status, this.getTotalPages(this.getConfigByStatus(status)));
  }

  onItemsPerPageChange(value: number): void {
    this.regPag = Number(value);
    this.getConfigs().forEach((config) => {
      config.itemsPerPage = this.regPag;
      config.currentPage = 1;
    });

    if (this.activaproyecto) {
      this.applyFiltersIncidencias();
    }
  }

  public number(valor: number): boolean {
    return valor > Constantes.CERO;
  }

  public cambiaEstatus(value) {
    if (null === value || "" === value) {
      return "";
    }
    return FiltrosIncidenciaEnum[value];
  }

  /* ---------- Catálogos de los filtros ---------- */
  protected cargaPrioridades(): void {
    this.incidenciasService.consultaPrioridad().subscribe((res) => {
      this.listaprioridades = res;
      this.repinta();
    });
  }

  protected cargaTipos(): void {
    this.incidenciasService.consultaTipo().subscribe((res) => {
      this.listaTipo = res;
      this.repinta();
    });
  }

  /** Los del puesto en el equipo de la etapa elegida, tomados del proyecto (ver etapa-incidencia.util). */
  protected cargaEmpleados(): void {
    this.listaEmpleados = equipoConPuesto(
      this.proy,
      this.selectEtapa,
      this.puestoEmpleados
    );
  }

  /** Copia al bean el rango de fechas del filtro; sin fecha final usa la de hoy. */
  private asignaRangoFechas(bean: Incidencias): void {
    if (this.fec_fin == null && this.fec_ini == null) {
      bean.fec_ini = null;
      bean.fec_fin = null;
    } else if (this.fec_fin != null && this.fec_ini != null) {
      bean.fec_ini = this.datePipe.transform(this.fec_ini, FORMATO_FECHA);
      bean.fec_fin = this.datePipe.transform(this.fec_fin, FORMATO_FECHA);
    } else if (this.fec_fin == null && this.fec_ini != null) {
      bean.fec_ini = this.datePipe.transform(this.fec_ini, FORMATO_FECHA);
      bean.fec_fin = this.datePipe.transform(new Date(), FORMATO_FECHA);
    } else if (this.fec_ini == null && this.fec_fin != null) {
      this.avisaFechaInicial();
    }
  }

  /**
   * Pide las incidencias; con la respuesta aplica alResponder y, con o sin
   * error, quita la carga. Si el backend falla responde 200 sin cuerpo: eso no
   * se aplica (y ya no deja la carga puesta por un TypeError).
   */
  private pideIncidencias(
    consulta: ConsultaList<Incidencias>,
    alResponder: (res: ConsultaList<Incidencias>) => void
  ): void {
    this.incidenciasService.consultarIncidencias(consulta).subscribe({
      next: (res) => {
        if (res?.bean2?.incDTO) {
          alResponder(res);
        }
        this.loading = false;
        this.repinta();
      },
      error: () => {
        this.loading = false;
        this.repinta();
      },
    });
  }

  /**
   * La app corre sin zone.js: tras una respuesta HTTP la vista no se repinta
   * sola. El tablero de desarrollo no lo hacía y al entrar se quedaba en 0
   * incidencias hasta el siguiente clic.
   */
  protected repinta(): void {
    if (this.destruido) {
      return;
    }
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  private changeStatusPage(status: string, page: number): void {
    const config = this.getConfigByStatus(status);
    const totalPages = this.getTotalPages(config);
    if (!config || page < 1 || page > totalPages || page === config.currentPage) {
      return;
    }

    this.pageChanged(page, status);
  }

  private getConfigs(): any[] {
    return [
      this.configAbierto,
      this.configObservacion,
      this.configProceso,
      this.configResuelto,
      this.configRevision,
      this.configVOBO,
      this.configCancelado,
    ];
  }
}
